import React, { } from 'react';
import { List, Datagrid, TextField, TextInput, Filter, FunctionField } from 'react-admin';
import { usePermissions } from 'react-admin';
import { cloneElement } from 'react';
import {
    useListContext,
    TopToolbar,
    ExportButton,
    sanitizeListRestProps,
} from 'react-admin';
const config = require('../../config.json');

const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        showFilter,
        total,
    } = useListContext();
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            {permissions.includes("disconnections.export") &&
                <ExportButton
                    label="Exportar csv"
                    disabled={total === 0}
                    resource={resource}
                    sort={currentSort}
                    filterValues={filterValues}
                    maxResults={maxResults}
                />
            }
        </TopToolbar>
    );
};

// export const DisconnectionList = props => {
//     const permissions = usePermissions().permissions;
//     if (!permissions) {
//         return null;
//     }
//     return (
//         <List filters={<DisconnectionFilter />} {...props} sort={{ field: 'id', order: 'DESC' }} title="Desconexiones" actions={<ListActions />} >
//             <Datagrid>
//                 {/* <TextField source="id" label="ID" /> */}
//                 <TextField source="code" label="Máquina" />
//                 {(permissions.includes("machines.list")) ?
//                     <ReferenceField source="code" label='Última conexión máquina' reference="machines" link={null} sortable={false}>
//                         <FunctionField label="Última conexión máquina" render={record => `${record.lastConnection || ""}`} />
//                     </ReferenceField>
//                     : null}
//                 {/* <TextField source="inactive" label='Fecha conexión' /> */}
//                 <FunctionField source="inactive" label='Fecha conexión' render={record => record.inactive.split(".")[0]} />
//                 <FunctionField source="active" label='Fecha reinicio' render={record => (
//                     record.active ? record.active : "-"
//                 )} />
//                 <FunctionField label="Tiempo sin conexión (hr)" render={record => {
//                     const date = Date.parse(record.inactive);
//                     let numero = date;
//                     let now = new Date();
//                     let diff;
//                     if (record.active !== "null" && record.active !== null && record.active !== "" && record.active !== undefined) {
//                         now = Date.parse(record.active);
//                         diff = numero - now;
//                     } else {
//                         diff = numero - now.getTime() + 4 * 60000 * 60;
//                     }
//                     // calculates amout of hours since record.lastConnection
//                     // const diffMinutes = Math.abs(diff / (1000 * 60));
//                     const diffMinutes = Math.abs(diff / (1000 * 60)) - 10;
//                     let diffHours = Math.floor(diffMinutes / 60);
//                     let restMinutes = Math.round(diffMinutes - (diffHours * 60));
//                     // const diffHours = Math.abs(diff / (1000 * 60 * 60));
//                     // if (diffHours.toFixed(1) > 0.5) {
//                     if (restMinutes.toString().length === 1) {
//                         restMinutes = "0" + restMinutes.toString();
//                     }
//                     if (diffHours.toString().length === 1) {
//                         diffHours = "0" + diffHours.toString();
//                     }
//                     return `${diffHours}:${restMinutes}`;
//                     // }
//                     // return Math.round(diffMinutes);
//                 }} />
//                 <FunctionField label="Detener contador" render={record => {
//                     if (record.active === "null" || record.active === null || record.active === "" || record.active === undefined) {
//                         return (
//                             <button onClick={() => {
//                                 if (alert("¿Estás seguro de detener el contador y no esperar a que se guarde automáticamente?")) {

//                                     console.log(record);
//                                     fetch(config.API_URL + "/disconnections/" + record.id, {
//                                         method: 'PUT',
//                                         body: JSON.stringify({
//                                             code: record.code,
//                                         }),
//                                         headers: {
//                                             'Accept': 'application/json',
//                                             'Content-Type': 'application/json',
//                                         }
//                                     }).then(res => res.json())
//                                         .then(data => {
//                                             window.location.reload();
//                                             console.log("Recargar 1");
//                                             console.log(data);
//                                         })
//                                         .catch(err => {
//                                             window.location.reload();
//                                             console.log("Recargar 2");
//                                             console.log(err);
//                                         });
//                                 }
//                             }}>Detener contador</button>
//                         );
//                     }
//                 }} />
//                 <TextField label="Desconexiones mes" source="amount" defaultValue={1} />
//             </Datagrid>
//         </List>
//     )
// };

export const DisconnectionList = props => {
    // const permissions = usePermissions().permissions;
    // if (!permissions) {
    //     return null;
    // }
    return (
        <List filters={<DisconnectionFilter />} {...props} sort={{ field: 'id', order: 'DESC' }} title="Desconexiones" actions={<ListActions />} >
            <Datagrid>
                <TextField source="code" label="Máquina" />
                {/* {(permissions.includes("machines.list")) ?
                    <ReferenceField source="code" label='Última conexión máquina' reference="machines" link={null} sortable={false}>
                        <FunctionField label="Última conexión máquina" render={record => `${record.lastConnection || ""}`} />
                    </ReferenceField>
                    : null} */}
                <FunctionField source="inactive" label='Fecha última conexión' render={record => record.inactive.split(".")[0]} />
                <TextField label="Desconexiones mes" source="amount" defaultValue={1} />
                <FunctionField label="Tiempo sin conexión mes (hr)" render={record => {
                    let diffMinutes = record.disconnection_minutes || 0;
                    let diffHours = Math.floor(diffMinutes / 60);
                    let restMinutes = Math.round(diffMinutes - (diffHours * 60));
                    // const diffHours = Math.abs(diff / (1000 * 60 * 60));
                    // if (diffHours.toFixed(1) > 0.5) {
                    if (restMinutes.toString().length === 1) {
                        restMinutes = "0" + restMinutes.toString();
                    }
                    if (diffHours.toString().length === 1) {
                        diffHours = "0" + diffHours.toString();
                    }
                    return `${diffHours}:${restMinutes}`;
                    // }
                    // return Math.round(diffMinutes);
                }} />
                <FunctionField source="no_active" label='Desconectada' render={record => (
                    record.no_active
                )} />
                <FunctionField label="Detener contador" render={record => {
                    if (record.no_active === "SI") {
                        return (
                            <button onClick={() => {
                                if (window.confirm("¿Estás seguro de detener el contador y no esperar a que se guarde automáticamente?")) {
                                    fetch(config.API_URL + "/disconnections/" + record.id, {
                                        method: 'PUT',
                                        body: JSON.stringify({
                                            code: record.code,
                                        }),
                                        headers: {
                                            'Accept': 'application/json',
                                            'Content-Type': 'application/json',
                                        }
                                    }).then(res => res.json())
                                        .then(data => {
                                            window.location.reload();
                                            console.log("Recargar 1");
                                            console.log(data);
                                        })
                                        .catch(err => {
                                            window.location.reload();
                                            console.log("Recargar 2");
                                            console.log(err);
                                        });
                                }
                            }}>Detener contador</button>
                        );
                    }
                }} />
            </Datagrid>
        </List>
    )
};

const DisconnectionFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar máquina" source="q" alwaysOn />
    </Filter>
);